import React, { useCallback, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import Pricing from "@/components/Pricing";
import ForBusiness from "@/components/ForBusiness";
import ForSeniors from "@/components/ForSeniors";
import PartnerServis from "@/components/PartnerServis";
import StrategickyPartner from "@/components/StrategickyPartner";
import About from "@/components/About";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import SeoLocations from "@/components/SeoLocations";
import Company from "@/components/Company";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import WhatsAppFab from "@/components/WhatsAppFab";
import { CookieProvider } from "@/components/CookieBanner";
import Privacy from "@/pages/Privacy";
import CookiesPage from "@/pages/Cookies";
import Terms from "@/pages/Terms";
import LegalNotice from "@/pages/LegalNotice";
import OrderPage from "@/pages/Order";
import SharedOrderPage from "@/pages/SharedOrder";
import { AdminLogin, AdminOrders, AdminOrderDetail } from "@/pages/Admin";
import { ClientLogin, ClientVerify, ClientDashboard } from "@/pages/Client";
import InstallPWA from "@/components/InstallPWA";

function HomePage() {
  const [preset, setPreset] = useState(null);
  const handleOrder = useCallback((item) => {
    window.location.href = `/objednavka?service=${encodeURIComponent(item.id)}`;
  }, []);
  const consumePreset = useCallback(() => setPreset(null), []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Services />
        <HowItWorks />
        <Pricing onOrder={handleOrder} />
        <ForBusiness />
        <ForSeniors />
        <PartnerServis />
        <StrategickyPartner />
        <About />
        <FAQ />
        <Contact preset={preset} onConsumePreset={consumePreset} />
      </main>
      <SeoLocations />
      <Company />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <CookieProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/ochrana-osobnich-udaju" element={<Privacy />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="/obchodni-podminky" element={<Terms />} />
            <Route path="/pravni-pouceni" element={<LegalNotice />} />
            <Route path="/objednavka" element={<OrderPage />} />
            <Route path="/objednavka/:token" element={<SharedOrderPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/objednavky" element={<AdminOrders />} />
            <Route path="/admin/objednavky/:orderNumber" element={<AdminOrderDetail />} />
            <Route path="/klient" element={<ClientLogin />} />
            <Route path="/klient/overit" element={<ClientVerify />} />
            <Route path="/klient/objednavky" element={<ClientDashboard />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
          <ChatWidget />
          <WhatsAppFab />
          <InstallPWA />
        </CookieProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
